import { Menu, MenuItem, PopoverPosition } from "@mui/material";
import { mixpanel } from "common/analytics";
import { useTranslation } from "common/locales";
import { GeneralFeedEvent } from "model";
import { Dispatch, SetStateAction } from "react";

interface Props {
  feedEvent: GeneralFeedEvent;
  anchor: HTMLElement | null;
  anchorPosition?: PopoverPosition;
  close: () => void;
  setDialogOpen: Dispatch<SetStateAction<boolean>>;
}
export default function FeedEventMoreMenu({
  feedEvent,
  anchor,
  anchorPosition,
  close,
  setDialogOpen,
}: Props) {
  const { t } = useTranslation();
  return (
    <Menu
      anchorEl={anchor}
      anchorPosition={anchorPosition}
      anchorReference={
        anchor ? "anchorEl" : anchorPosition ? "anchorPosition" : "none"
      }
      open={anchor ? anchor.id === feedEvent.guid : false}
      onClose={close}
      key={`fe-menu-${feedEvent.guid}`}
    >
      <MenuItem
        key={`fe-menuitem-edit-${feedEvent.guid}`}
        onClick={() => {
          mixpanel.track("Edit/view feed event clicked");
          setDialogOpen(true);
          close();
        }}
      >
        {t("feedPurchaseEvent.menu.editView")}
      </MenuItem>
    </Menu>
  );
}
